"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormElementTypeEnum = void 0;
var FormElementTypeEnum;
(function (FormElementTypeEnum) {
    FormElementTypeEnum["INPUT"] = "input";
    FormElementTypeEnum["TEXT"] = "text";
    FormElementTypeEnum["HTML"] = "html";
    FormElementTypeEnum["NUMBER"] = "number";
    FormElementTypeEnum["SELECT"] = "select";
    FormElementTypeEnum["TYPEAHEAD"] = "typeahead";
    FormElementTypeEnum["LIST"] = "list";
    FormElementTypeEnum["SECTION"] = "section";
    FormElementTypeEnum["TIME"] = "time";
    FormElementTypeEnum["DATE"] = "date";
    FormElementTypeEnum["DATETIME"] = "datetime";
    FormElementTypeEnum["SWITCH"] = "switch";
    FormElementTypeEnum["RADIO"] = "radio";
    FormElementTypeEnum["CHECKBOXES"] = "checkboxes";
    FormElementTypeEnum["CHECKBOX"] = "checkbox";
    FormElementTypeEnum["CUSTOM"] = "custom";
    FormElementTypeEnum["FILE"] = "file";
})(FormElementTypeEnum = exports.FormElementTypeEnum || (exports.FormElementTypeEnum = {}));
